"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_ROLE_DEFINITIONS = void 0;
const user_entity_1 = require("../users/user.entity");
const role_permissions_1 = require("./role-permissions");
exports.SYSTEM_ROLE_DEFINITIONS = [
    {
        key: user_entity_1.UserRole.ADMIN,
        name: 'Admin',
        description: 'Full operational control across customers, products, inventory, support, and business settings.',
        permissions: role_permissions_1.ROLE_PERMISSIONS[user_entity_1.UserRole.ADMIN],
        isSystem: true,
    },
    {
        key: user_entity_1.UserRole.CALL_CENTER,
        name: 'Call Center',
        description: 'Handles customer interactions, order creation, ticket management, and consultation booking.',
        permissions: role_permissions_1.ROLE_PERMISSIONS[user_entity_1.UserRole.CALL_CENTER],
        isSystem: true,
    },
    {
        key: user_entity_1.UserRole.LOGISTICS,
        name: 'Logistics',
        description: 'Runs dispatch, fulfillment, stock movement, and logistics issue resolution.',
        permissions: role_permissions_1.ROLE_PERMISSIONS[user_entity_1.UserRole.LOGISTICS],
        isSystem: true,
    },
    {
        key: user_entity_1.UserRole.DOCTOR,
        name: 'Doctor',
        description: 'Reviews medical records, validates documentation, and manages consultation notes.',
        permissions: role_permissions_1.ROLE_PERMISSIONS[user_entity_1.UserRole.DOCTOR],
        isSystem: true,
    },
    {
        key: user_entity_1.UserRole.TEAM_LEAD,
        name: 'Team Lead',
        description: 'Monitors queues, resolves escalations, and reviews higher-risk operational actions.',
        permissions: role_permissions_1.ROLE_PERMISSIONS[user_entity_1.UserRole.TEAM_LEAD],
        isSystem: true,
    },
    {
        key: user_entity_1.UserRole.MANAGEMENT,
        name: 'Management',
        description: 'Owns oversight, reporting, approvals, and high-level exception workflows.',
        permissions: role_permissions_1.ROLE_PERMISSIONS[user_entity_1.UserRole.MANAGEMENT],
        isSystem: true,
    },
];
